import 'uno.css'
import 'ant-design-vue/dist/reset.css'
import './design/index.less'

// Register icon sprite
import 'virtual:svg-icons-register'
import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import DataVVue3 from '@kjgl77/datav-vue3'
import VueNativeSock from 'vue-native-websocket-vue3'
import App from './App.vue'
import { initAppConfigStore } from '@/logics/initAppConfig'
import { setupErrorHandle } from '@/logics/error-handle'
import { router, setupRouter } from '@/router'
import { setupRouterGuard } from '@/router/guard'
import { setupStore } from '@/store'
import { setupGlobDirectives } from '@/directives'
import { setupI18n } from '@/locales/setupI18n'
import { registerGlobComp } from '@/components/registerGlobComp'
import Directives from '@/businessComponents/Directives'
import { useVueNativeSockStore } from '@/store/modules/useSocketStoreWithOut'

// import { getAccessToken, getTenantId } from '@/utils/auth'

// import '@/utils/tongji'
// import './utils/rem.js'

async function bootstrap() {
  const app = createApp(App)

  // Configure store
  // 配置 store
  setupStore(app)

  // Initialize internal system configuration
  // 初始化内部系统配置
  initAppConfigStore()

  // Register global components
  // 注册全局组件
  registerGlobComp(app)

  // Multilingual configuration
  // 多语言配置
  // Asynchronous case: language files may be obtained from the server side
  // 异步案例：语言文件可能从服务器端获取
  await setupI18n(app)

  // Configure routing
  // 配置路由
  setupRouter(app)

  // router-guard
  // 路由守卫
  setupRouterGuard(router)

  // Register global directive
  // 注册全局指令
  setupGlobDirectives(app)

  // Configure global error handling
  // 配置全局错误处理
  setupErrorHandle(app)

  // https://next.router.vuejs.org/api/#isready
  // await router.isReady();

  app.use(Antd).use(DataVVue3).use(Directives).mount('#app')

  const piniaSocketStore = useVueNativeSockStore(app)

  // let url = ''
  // // 域名截取 wss
  // if (import.meta.env.MODE === 'development')
  // url = `wss://wx.chenlingkj.com.cn/infra/ws/?token=${getAccessToken()}&tenantId=${getTenantId()}`
  // else
  // url =`wss://${window.location.host}/infra/ws/?token=${getAccessToken()}&tenantId=${getTenantId()}`

  app.use(
    VueNativeSock,
    `wss://${window.location.host}/infra/ws`,
    {
      // 启用pinia集成 | enable pinia integration
      store: piniaSocketStore,
      // 数据发送/接收使用使用json
      format: 'string',
      // 开启手动调用 connect() 连接服务器
      connectManually: true,
      // 开启自动重连
      reconnection: true,
      // 尝试重连的次数
      reconnectionAttempts: 60,
      // 重连间隔时间
      reconnectionDelay: 30000,
    },
  )
}

bootstrap()
